<template>
  <v-dialog v-model="modalDialog" fullscreen>
    <template #activator="{ on: dialog, attrs }">
      <wx-btn-standard
        v-bind="attrs"
        v-on="{ ...dialog }"
        :ripple="false"
        :disabled="isPresenter"
        :title="$t('common.edit')"
        :class="btnCssClass"
        class="edit-production-run px-0"
        color="primary"
        small
        plain
        active
      >
        {{ $t("common.edit") }}
      </wx-btn-standard>
    </template>

    <article class="v-dialog__content">
      <header>
        <v-btn icon large @click="closeModalDialog" :title="$t('common.dialogFormCancelHoverTitle')" class="close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2 class="mb-2 md-8 wx-typo-h1">{{ $t("dashboard.productionRun.modifyTitle") }}</h2>
      </header>

      <production-run-form
        v-if="modalDialog"
        ref="productionRunForm"
        :initial-production-run="productionRun"
        @close="closeModalDialog"
        @submit="submitProductionRun"
      />
    </article>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ProductionRunForm from "@/components/dashboard/productionRun/ProductionRunForm.vue";
import WxBtnStandard from "@/components/ui/WxBtnStandard.vue";

export default {
  name: "ModifyProductionRunDialog",
  components: {
    WxBtnStandard,
    ProductionRunForm,
  },
  props: {
    productionRun: {
      type: Object,
      required: true,
    },
    btnCssClass: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      modalDialog: false,
    };
  },
  computed: {
    ...mapGetters("user", ["isPresenter"]),
  },
  methods: {
    ...mapActions("dashboard", ["updateProductionRun"]),
    submitProductionRun(submission) {
      const formattedSubmission = {
        eventId: submission.eventId,
        sku: submission.sku,
        work_order_number: submission.workOrder,
        lot_number: submission.lotNumber,
        number_of_employees: submission.numberOfEmployees,
        planned_quantity: submission.plannedQuantity,
        effective_start_time: submission.startTime,
      };
      this.updateProductionRun(formattedSubmission).then(this.closeModalDialog);
    },
    closeModalDialog() {
      this.$emit("close");
      this.modalDialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-base-theme);

  &__content {
    display: flex;
    align-items: center;
    flex-flow: column nowrap;
    position: initial;
    left: auto;
    width: 100%;
    max-width: 600px;
    padding-inline: var(--grid-gutter);
    pointer-events: auto;

    header {
      padding-top: var(--grid-gutter);

      .close-btn {
        position: fixed;
        z-index: 1; // hover fields
        top: var(--dialog-close-offset);
        right: var(--dialog-close-offset);
      }
    }
    .v-form {
      width: 100%;

      fieldset {
        border: none;

        &.form-footer-actions {
          display: flex;
          justify-content: flex-end;
          column-gap: var(--btn-inline-margin);
          padding-bottom: var(--grid-gutter);
        }
      }

      // Responsive Columns
      .row {
        margin-top: 0;
        margin-bottom: 0;
        .field-col {
          padding-top: 0;
          padding-bottom: 0;
        }
      }
    }
  }
}

.v-btn {
  &.product-selected,
  &.no-product-selected {
    font-weight: 400;
    font-size: var(--font-size-h3);
    max-height: 30px;

    ::v-deep .v-btn__content {
      .text-string {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
